import type { MarketGroupingConfig, PreviewParam, MarketSportGroup } from "@/shared/model/grouping";

const marketGroupingConfig = {
    grouped_markets: [
        {
            group_code: "TOTAL_GOALS_OVER/UNDER",
            market_name: "POČET GÓLŮ V ZÁPASE",
        },
        {
            group_code: "HANDICAP_2_WAY",
            market_name: "HANDICAP",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_ASIAN",
            market_name: "POČET GÓLŮ V ZÁPASE SPECIÁLNÍ",
        },
        {
            group_code: "HANDICAP",
            market_name: "HANDICAP S REMÍZOU",
        },
        {
            group_code: "ASIAN_HANDICAP",
            market_name: "HANDICAP SPECIÁLNÍ",
        },
        {
            group_code: "CORNERS_OVER/UNDER",
            market_name: "POČET ROHŮ V ZÁPASE",
        },
        {
            group_code: "HANDICAP_1ST_HALF",
            market_name: "1.POLOČAS: HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_1ST_HALF_HOME",
            market_name: "TÝM 1: 1.POLOČAS - POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_1ST_HALF_AWAY",
            market_name: "TÝM 2: 1.POLOČAS - POČET GÓLŮ",
        },
        {
            group_code: "ASIAN_HANDICAP_2ND_HALF",
            market_name: "2.POLOČAS: HANDICAP SPECIÁLNÍ",
        },
        {
            group_code: "HANDICAP_2_WAY_1ST_HALF",
            market_name: "1.POLOČAS: HANDICAP",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_1ST_HALF",
            market_name: "1.POLOČAS: POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_AFTER_10_MINS",
            market_name: "PRVNÍCH 10 MIN: POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_ASIAN_1ST_HALF",
            market_name: "1.POLOČAS: POČET GÓLŮ SPECIÁLNÍ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_ASIAN_2ND_HALF",
            market_name: "2.POLOČAS: POČET GÓLŮ SPECIÁLNÍ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_AFTER_10_MINS_HOME",
            market_name: "TÝM 1: PRVNÍCH 10 MIN - POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_AFTER_10_MINS_AWAY",
            market_name: "TÝM 2: PRVNÍCH 10 MIN - POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_HOME",
            market_name: "TÝM 1: POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_AWAY",
            market_name: "TÝM 2: POČET GÓLŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_1ST_10_MINS",
            market_name: "PRVNÍCH 10 MIN: POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_1ST_10_MINS_HOME",
            market_name: "TÝM 1: PRVNÍCH 10 MIN - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_1ST_10_MINS_AWAY",
            market_name: "TÝM 2: PRVNÍCH 10 MIN - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_HANDICAP_2_WAY",
            market_name: "ROHY HANDICAP",
        },
        {
            group_code: "CORNERS_OVER/UNDER_HOME",
            market_name: "TÝM 1: POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_AWAY",
            market_name: "TÝM 2: POČET ROHŮ",
        },
        {
            group_code: "HANDICAP_2_WAY_1ST_10_MINS",
            market_name: "PRVNÍCH 10 MIN: HANDICAP",
        },
        {
            group_code: "CORNERS_OVER/UNDER_HOME_1ST_HALF",
            market_name: "TÝM 1: 1.POLOČAS - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_AWAY_1ST_HALF",
            market_name: "TÝM 2: 1.POLOČAS - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_HANDICAP_2_WAY_1ST_HALF",
            market_name: "1.POLOČAS: ROHY HANDICAP",
        },
        {
            group_code: "CORNERS_OVER/UNDER_1ST_HALF",
            market_name: "1.POLOČAS: POČET ROHŮ",
        },
        {
            group_code: "HANDICAP_2_WAY_2ND_HALF",
            market_name: "2.POLOČAS: HANDICAP",
        },
        {
            group_code: "HANDICAP_2ND_HALF",
            market_name: "2.POLOČAS: HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_2ND_HALF",
            market_name: "2.POLOČAS: POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_2ND_HALF_HOME",
            market_name: "TÝM 1: 2.POLOČAS - POČET GÓLŮ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_2ND_HALF_AWAY",
            market_name: "TÝM 2: 2.POLOČAS - POČET GÓLŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_HOME_2ND_HALF",
            market_name: "TÝM 1: 2.POLOČAS - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_AWAY_2ND_HALF",
            market_name: "TÝM 2: 2.POLOČAS - POČET ROHŮ",
        },
        {
            group_code: "CORNERS_OVER/UNDER_2ND_HALF",
            market_name: "2.POLOČAS: POČET ROHŮ",
        },
        {
            group_code: "HANDICAP_2_WAY_INC_OT_PENS",
            market_name: "HANDICAP DO ROZHODNUTÍ",
        },
        {
            group_code: "HANDICAP_3_WAY",
            market_name: "HANDICAP S REMÍZOU DO ROZHODNUTÍ ",
        },
        {
            group_code: "TOTAL_GOALS_OVER/UNDER_INC_OT_AND_PENS",
            market_name: "POČET GÓLŮ DO ROZHODNUTÍ (NAD/POD)",
        },
        {
            group_code: "TOTAL_GOALS_O/U/E_INC_OT_AND_PENALTIES",
            market_name: "POČET GÓLŮ DO ROZHODNUTÍ (NAD/POD/PŘESNĚ)",
        },
        {
            group_code: "TOTAL_HOME_GOALS_OVER_UNDER_INC_OT_PENS",
            market_name: "TÝM 1: POČET GÓLŮ DO ROZHODNUTÍ",
        },
        {
            group_code: "TOTAL_AWAY_GOALS_OVER_UNDER_INC_OT_PENS",
            market_name: "TÝM 2: POČET GÓLŮ DO ROZHODNUTÍ",
        },
        {
            group_code: "PERIOD_TOTAL_GOALS_FIRST_PERIOD",
            market_name: "1.TŘETINA: POČET GÓLŮ (NAD/POD/PŘESNĚ)",
        },
        {
            group_code: "HANDICAP_3_WAY_FIRST_PERIOD",
            market_name: "1.TŘETINA: HANDICAP S REMÍZOU",
        },
        {
            group_code: "PERIOD_TOTAL_GOALS_SECOND_PERIOD",
            market_name: "2.TŘETINA: POČET GÓLŮ (NAD/POD/PŘESNĚ)",
        },
        {
            group_code: "HANDICAP_3_WAY_SECOND_PERIOD",
            market_name: "2.TŘETINA: HANDICAP S REMÍZOU",
        },
        {
            group_code: "PERIOD_TOTAL_GOALS_THIRD_PERIOD",
            market_name: "3.TŘETINA: POČET GÓLŮ (NAD/POD/PŘESNĚ)",
        },
        {
            group_code: "HANDICAP_3_WAY_THIRD_PERIOD",
            market_name: "3.TŘETINA: HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_GAMES_OVER/UNDER",
            market_name: "POČET HER",
        },
        {
            group_code: "GAME_HANDICAP",
            market_name: "HRY HANDICAP",
        },
        {
            group_code: "SET_HANDICAP",
            market_name: "SETY HANDICAP",
        },
        {
            group_code: "TOTAL_GAMES_OVER/UNDER_HOME",
            market_name: "HRÁČ 1: POČET HER",
        },
        {
            group_code: "TOTAL_GAMES_OVER/UNDER_AWAY",
            market_name: "HRÁČ 2: POČET HER",
        },
        {
            group_code: "HANDICAP_2_WAY",
            market_name: "HANDICAP",
        },
        {
            group_code: "HANDICAP",
            market_name: "HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER",
            market_name: "POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_HOME",
            market_name: "TÝM 1: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_AWAY",
            market_name: "TÝM 2: POČET BODŮ",
        },
        {
            group_code: "MATCH_WINNER_POINT_HANDICAP",
            market_name: "BODY HANDICAP",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER",
            market_name: "POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_HOME",
            market_name: "TÝM 1: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_AWAY",
            market_name: "TÝM 2: POČET BODŮ",
        },
        {
            group_code: "MATCH_WINNER_SET_HANDICAP",
            market_name: "SETY HANDICAP",
        },
        {
            group_code: "TOTAL_SETS_OVER/UNDER",
            market_name: "POČET SETŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_FIRST_SET",
            market_name: "1.SET: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_SECOND_SET",
            market_name: "2.SET: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_THIRD_SET",
            market_name: "3.SET: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_FOURTH_SET",
            market_name: "4.SET: POČET BODŮ",
        },
        {
            group_code: "TOTAL_POINTS_OVER/UNDER_FIFTH_SET",
            market_name: "5.SET: POČET BODŮ",
        },
        {
            group_code: "SET_WINNER_FIRST_SET_HANDICAP",
            market_name: "1.SET: BODY HANDICAP",
        },
        {
            group_code: "SET_WINNER_SECOND_SET_HANDICAP",
            market_name: "2.SET: BODY HANDICAP",
        },
        {
            group_code: "SET_WINNER_THIRD_SET_HANDICAP",
            market_name: "3.SET: BODY HANDICAP",
        },
        {
            group_code: "SET_WINNER_FOURTH_SET_HANDICAP",
            market_name: "4.SET: BODY HANDICAP",
        },
        {
            group_code: "SET_WINNER_FIFTH_SET_HANDICAP",
            market_name: "5.SET: BODY HANDICAP",
        },
        {
            group_code: "HANDICAP_2_WAY",
            market_name: "HANDICAP",
        },
        {
            group_code: "TOTAL_RUNS_OVER/UNDER",
            market_name: "POČET BODŮ (NAD/POD)",
        },
        {
            group_code: "TOTAL_RUNS_O/U/E",
            market_name: "POČET BODŮ (NAD/POD/PŘESNĚ)",
        },
        {
            group_code: "FIRST_3_INNINGS_TOTAL_RUNS_O/U/E",
            market_name: "PRVNÍ 3 SMĚNY: POČET BODŮ",
        },
        {
            group_code: "FIRST_5_INNINGS_TOTAL_RUNS_O/U/E",
            market_name: "PRVNÍCH 5 SMĚN: POČET BODŮ",
        },
        {
            group_code: "FIRST_7_INNINGS_TOTAL_RUNS_O/U/E",
            market_name: "PRVNÍCH 7 SMĚN: POČET BODŮ",
        },
        {
            group_code: "HANDICAP_2_WAY",
            market_name: "HANDICAP",
        },
        {
            group_code: "MATCH_HANDICAP",
            market_name: "HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_POINTS_O/U",
            market_name: "POČET BODŮ",
        },
        {
            group_code: "HANDICAP_2_WAY_1ST_HALF",
            market_name: "1.POLOČAS: HANDICAP",
        },
        {
            group_code: "HANDICAP_3_WAY_1ST_HALF",
            market_name: "1.POLOČAS: HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_POINTS_O/U_1ST_HALF",
            market_name: "1.POLOČAS: POČET BODŮ",
        },
        {
            group_code: "MATCH_HANDICAP_2_WAY",
            market_name: "HANDICAP",
        },
        {
            group_code: "MATCH_HANDICAP",
            market_name: "HANDICAP S REMÍZOU",
        },
        {
            group_code: "MATCH_HANDICAP_1ST_HALF_2_WAY",
            market_name: "1.POLOČAS: HANDICAP",
        },
        {
            group_code: "MATCH_HANDICAP_1ST_HALF",
            market_name: "1.POLOČAS: HANDICAP S REMÍZOU",
        },
        {
            group_code: "TOTAL_ROUNDS_OVER/UNDER_MAP_1",
            market_name: "1.MAPA: POČER KOL",
        },
        {
            group_code: "TOTAL_ROUNDS_OVER/UNDER_MAP_2",
            market_name: "2.MAPA: POČER KOL",
        },
        {
            group_code: "TOTAL_ROUNDS_OVER/UNDER_MAP_3",
            market_name: "3.MAPA: POČER KOL",
        },
        {
            group_code: "HANDICAP_MAP_1",
            market_name: "1.MAPA: HANDICAP",
        },
        {
            group_code: "HANDICAP_MAP_2",
            market_name: "2.MAPA: HANDICAP",
        },
        {
            group_code: "HANDICAP_MAP_3",
            market_name: "3.MAPA: HANDICAP",
        },
    ],
} as MarketGroupingConfig;

const config = environment.config;

export default function useMock() {
    const getGroupingConfig = (): MarketGroupingConfig => {
        return marketGroupingConfig;
    };

    const getMarketPreviewConfig = (sportCode: string = null): Array<PreviewParam> => {
        const previewConfig = config["market-preview"];

        if (!previewConfig) {
            console.error("Market preview config not found");
        }

        const group = previewConfig?.find((g) => g.sport_code === sportCode);
        return group ? group.markets : [];
    };

    const getMarketPreviewConfigAll = (): Array<MarketSportGroup> => {
        const previewConfig = config["market-preview"];

        if (!previewConfig) {
            console.error("Market preview config not found");
        }

        return previewConfig;
    };

    const sportHasMarketPreviewConfig = (sportCode: string) => {
        const previewConfig = config["market-preview"];
        return previewConfig.some((g) => g.sport_code === sportCode);
    };

    const sportIsCustomGrouped = (sportCode: string): boolean => {
        return config["sports-custom-grouped"].includes(sportCode);
    };

    return {
        getGroupingConfig,
        getMarketPreviewConfig,
        getMarketPreviewConfigAll,
        sportHasMarketPreviewConfig,
        sportIsCustomGrouped,
    };
}
